import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Euro from './pages/Euro';
import Shekel from './pages/Shekel';
import Admin from './pages/Admin';
import Statistics from './pages/Statistics';
import Gifts from './pages/Gifts';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import './types/i18n';

// Redirect component that preserves query parameters
const RedirectToEng = () => {
  const location = useLocation();
  return <Navigate to={`/eng${location.search}`} replace />;
};

function App() {
  return (
    <Router>
      <div className="min-h-screen text-center flex flex-col">
        <main className="flex-grow">
          <Routes>
            <Route path="/eng" element={<Home lang="en" />} />
            <Route path="/eng/euro" element={<Euro lang="en" />} />
            <Route path="/eng/shekel" element={<Shekel lang="en" />} />
            <Route path="/it" element={<Home lang="it" />} />
            <Route path="/it/euro" element={<Euro lang="it" />} />
            <Route path="/it/shekel" element={<Shekel lang="it" />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/stats"
              element={
                <ProtectedRoute>
                  <Statistics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gifts"
              element={
                <ProtectedRoute>
                  <Gifts />
                </ProtectedRoute>
              }
            />
            {/* Default: redirect to English, preserving query params */}
            <Route path="/" element={<RedirectToEng />} />
            <Route path="*" element={<RedirectToEng />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
